import { z } from 'zod';
const frequency = z.union([z.literal('Monthly'), z.literal('Weekly')]);
const invoiceCharge = z.object({
    id: z.number(),
    invoiceDefinitionId: z.number(),
    name: z.string(),
    amount: z.number(),
    type: z.string(),
    createdOn: z.string(),
    updatedOn: z.string().nullable(),
});
const invoiceDefinition = z.object({
    id: z.number(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    createdOn: z.coerce.date(),
    isUsed: z.boolean(),
    frequency,
    isTrial: z.boolean(),
    crewChargeMinimum: invoiceCharge.optional(),
    gspCharge: invoiceCharge.optional(),
    crewCharge: invoiceCharge.optional(),
    storeName: z.string(),
    isTest: z.boolean(),
    isActive: z.boolean(),
});
const invoiceDefinitionCreate = z.object({
    termInMonths: z.number(),
    name: z.string(),
    frequency,
    startDate: z.string(),
    amount: z.number(),
    minimumAmount: z.number(),
    gspDiscount: z.number(),
});
export const commandInvoiceDefinition = {
    base: invoiceDefinition,
    charge: invoiceCharge,
    create: invoiceDefinitionCreate,
};
//# sourceMappingURL=invoiceDefinition.js.map